﻿// @ sourceURL=Tab.Scroll.UI.class.js
export default class TabsScrollUi {
	constructor($container) {
		if (!$container) {
			throw new Error("Cannot create a TabsScrollUI without supplying a tabs container element ($container)");
		}
		this.$container = $container;
	}

	initializeScrollableTabs(clickCallback) {
		$(this.$container).scrollTabs({
			scroll_distance: 350,
			scroll_duration: 350,
			left_arrow_size: 26,
			right_arrow_size: 26,
			click_callback: clickCallback,
		});
	}
}
